export interface BatchFileUploadResponse {
  fileName: string
}

export function BatchFileUploadResponseFromJSON(
  json: any
): BatchFileUploadResponse {
  return BatchFileUploadResponseFromJSONTyped(json)
}

export function BatchFileUploadResponseFromJSONTyped(
  json: any
): BatchFileUploadResponse {
  if (json === undefined || json === null) {
    return json
  }
  return {
    fileName: json.file_name
  }
}
